
import React from 'react'

import sass from './column.sass'

export default function Column(props) {
  let {
    children,
    className,
    onClick,
    style,
    width
  } = props

  let classes = [sass.column]
  classes.push(className)

  return (
    <div onClick={onClick} className={classes.join(' ')} style={{ width, ...style}}>
      {children}
    </div>
  )
}
